var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-flex items-center px-6 py-2 mx-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none",class:{
        'bg-green-500 hover:bg-green-600  focus:border-green-300 focus:shadow-outline-green-600 active:bg-green-600':
            _vm.color === 'green',
        'bg-red-500 hover:bg-red-600  focus:border-red-300 focus:shadow-outline-red-600 active:bg-red-600':
            _vm.color === 'red'
    },attrs:{"type":"button"},on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }